<div class="framediv" [class]="className">
    <app-local-watch></app-local-watch>
    <app-heb-datetime [place]="location"></app-heb-datetime>

    <router-outlet></router-outlet>
</div>
